/**
 * 分类项数据
 */
export type NavTabsInfo = {
  /** 分类名称 */
  name: string;
  /** 分类ID */
  id: string | number;
  /** 是否选中当前分类 */
  actived?: boolean;
  /** 其他携带字段 */
  [key: string]: any;
};

/** 滚动条状态 */
export enum ScrollerState {
  /** 最左 */
  Start = 1,
  /** 最右 */
  End,
  /** 中间 */
  Middle
}

// 列表自动滚动的距离(px)
const DEF_SCROLL_DISTANCE = 120;
// 列表项距离2端的距离(px)（小于这个距离会认为是靠边，点击该项后会自动滚动列表，使其展示更多隐藏内容）
const DEF_SCROLL_OFFSET = 40;

/**
 * 获取点击2侧分类项后自动滚动整个区的距离
 * @param el 当前项
 * @param container 父容器
 * @returns
 */
export function getAutoScrollDistance(el: HTMLElement, container: HTMLElement) {
  const { right, left } = el.getBoundingClientRect();
  const { right: parentRight, left: parentLeft } = container.getBoundingClientRect();
  const defOffset = DEF_SCROLL_OFFSET;
  const defDistance = DEF_SCROLL_DISTANCE;
  // 计算移动距离
  let distance = 0;
  // 当点击靠右边的分类项时，需要将整个分类列表做左移动
  if (right + defOffset >= parentRight) {
    // 先将选中项移到可视区，再向左移动一个位置，展示更多隐藏项
    distance = Math.max(right - parentRight, 0) + defDistance;
  } else if (left <= parentLeft + defOffset) {
    // 当点击最左边的分类时，需要将整个分类列表做右移动
    // 先将选中项移到可视区，再向右移动一个位置，展示更多隐藏项
    distance = -(Math.max(parentLeft - left, 0) + defDistance);
  }
  return distance;
}

/**
 * 获取某个元素内容是否溢出状态
 * @param container
 * @returns
 */
export function getOverflowState(container: HTMLElement) {
  const { offsetHeight, offsetWidth, scrollHeight, scrollWidth } = container;
  return {
    isOverflowX: offsetWidth < scrollWidth,
    isOverflowY: offsetHeight < scrollHeight,
  };
}

/**
   * 计算滚动状态（靠近2端会展示半透明蒙层）
   * 导航列表可能的位置有3种：最左、最右、中间，可能同时存在2种状态，如刚好一整行时的最左和最右
   * @param container 滚动容器元素
   * @param defOffset tab项离边线的距离（tab离边线太近也认为是位于两端）
   * @returns
   */
export function getScrollState(container: HTMLElement, defOffset = 10): ScrollerState[] {
  const { scrollWidth, scrollLeft, offsetWidth } = container;
  // 判断导航栏左侧是否靠边
  const isStart = scrollLeft < defOffset;
  // 判断导航栏右侧是否靠边
  const isEnd = (scrollWidth - scrollLeft - offsetWidth) < defOffset;
  // 既不靠左也不靠右那就是靠中间
  if (!isStart && !isEnd) {
    return [ScrollerState.Middle];
  }
  const res: ScrollerState[] = [];
  if (isStart) {
    res.push(ScrollerState.Start);
  }
  if (isEnd) {
    res.push(ScrollerState.End);
  }
  return res;
}

